exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/masonpimentel/Repos/mason-blog/src/app/home/home.component.css
// module id = ../../../../../src/app/home/home.component.css
// module chunks = main